<template>
  <v-card class="rounded-card card-shadow">
    <v-card-text class="text--primary--color">
      <v-row dense class="mt-5">
        <v-col cols="12">
          Selecione abaixo os aprovadores para esta regra.
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <px-autocomplete-user-comprador-multiple
            dense
            outlined
            autocomplete="off"
            class="required rounded-tag-small"
            label="Usuários"
            :error="$v.regra.aprovadores.$error"
            @blur="$v.regra.aprovadores.$touch()"
            v-model="regra.aprovadores"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-switch dense
                    class="pa-0 mt-2 mr-2"
                    label="Requer aprovação de todos os responsáveis"
                    color="primary"
                    v-model="regra.requerAprovacaoTotal"/>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';

export default {
  mixins: [validationMixin],
  props: {
    regra: {
      type: Object,
      required: true,
    },
  },
  methods: {
    isValid() {
      return !this.validateForm();
    },
  },
  validations: {
    regra: {
      aprovadores: {
        required,
      },
    },
  },
};
</script>
